import classNames from 'classnames';
import { ReactNode } from 'react';
import { Badge } from 'yoso';
import { Boost2D } from '~/components/Icon';
import { AdditionalNftModel } from '~/components/Membership/Membership.hooks';
import { NftContent, NftContentProps } from '~/components/Nft/Content/NftContent';
import { formatBoost } from '~/components/Util/number';
import styles from './FriendNftContent.module.scss';

export type FriendNftContentProps = NftContentProps &
  Partial<Pick<AdditionalNftModel, 'meta'>> & {
    badge?: ReactNode;
    boost?: number;
  };

export const FriendNftContent = ({
  meta,
  contentsType = 'IMAGE',
  children,
  title = meta?.['Growth'],
  boost = meta?.['Boost'] ? Number(meta?.['Boost']) : 0,
  badge = (
    <Badge className={styles.badge}>
      <Boost2D />
      {formatBoost(boost)}%
    </Badge>
  ),
  className,
  ...contentProps
}: FriendNftContentProps) => (
  <NftContent
    {...contentProps}
    title={title}
    contentsType={contentsType}
    className={classNames(styles.root, className)}>
    {badge}
    {children}
  </NftContent>
);
